(function () {
  var main = document.getElementById('MainContent') || document.querySelector('main');
  if (!main) return;

  var sections = main.querySelectorAll('.shopify-section');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-visible'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

  sections.forEach(function (s) {
    var rect = s.getBoundingClientRect();
    // Görünür alanda ya da üstte kalan bölümleri anında göster (beyaz takılma olmasın)
    if (rect.top < window.innerHeight * 0.9) {
      s.classList.add('is-visible');
    } else {
      s.classList.add('celistia-reveal');
      io.observe(s);
    }
  });
})();
